import React, { useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'

type Props = {
  children: React.ReactElement
  siblingElement: Element
  after?: boolean
  style?: any
  id?: string
}

export const InsertedPortal = ({
  children,
  siblingElement,
  after = false,
  style = emptyObject,
  id,
}: Props) => {
  const [container, setContainer] = useState<HTMLElement>()

  useLayoutEffect(() => {
    const c = document.createElement('div')
    if (id) {
      c.id = id
    }
    Object.keys(style).forEach((key: any) => {
      c.style[key] = style[key]
    })
    after
      ? siblingElement.parentElement.insertBefore(c, siblingElement.nextSibling)
      : siblingElement.parentElement.insertBefore(c, siblingElement)
    setContainer(c)

    return () => {
      c.remove()
    }
  }, [after, style, siblingElement, id])

  return container ? createPortal(children, container) : null
}

const emptyObject = {}
